import { useAtomValue } from 'jotai'
import React from 'react'
import * as R from 'remeda'

import { useSurveyQueryCustomerAttributeGroups } from '~/hooks/useSurveyQuery'
import { intersectionBy } from '~/utils'

import { tabulatedCustomerAttributeIdsAtom } from '../atoms'

export const useTabulatedCustomerAttributeGroups = () => {
  const customerAttributeGroups = useSurveyQueryCustomerAttributeGroups()
  const tabulatedCustomerAttributeIds = useAtomValue(
    tabulatedCustomerAttributeIdsAtom,
  )

  return React.useMemo(
    () =>
      R.pipe(
        customerAttributeGroups,
        R.map((customerAttributeGroup) => ({
          ...customerAttributeGroup,
          customerAttributes: intersectionBy(
            customerAttributeGroup.customerAttributes,
            tabulatedCustomerAttributeIds,
            R.prop('id'),
            R.identity(),
          ),
        })),
        R.filter(
          (customerAttributeGroup) =>
            0 < customerAttributeGroup.customerAttributes.length,
        ),
      ),
    [customerAttributeGroups, tabulatedCustomerAttributeIds],
  )
}
